export const SAVE_DESIGN = "APP/EDITOR/SAVE_DESIGN";
export const LOAD_DESIGN = "APP/EDITOR/LOAD_DESIGN";
export const RESET_EDITOR_HISTORY = "APP/EDITOR/RESET_HISTORY";
